<template>
    <b-modal
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :title="titulo"
        centered
        size="lg"
        @hidden="cancelar"
        id="modal-organizar"
    >
        <load
            v-if="loading"
            mode="table"
            message="Alterando, aguarde a finalização."
        />
        <div v-else class="row px-3">
            <div class="alert alert-warning p-2">
                <i class="mdi mdi-alert mdi-24px"></i> Para mudar o responsável
                será necessário usar a opção de
                <b>Trocar responsável familia</b> na listagem de membros, abaixo
                será listado apenas os membros com posições diferentes de
                responsável.
            </div>
            <OrganizarPosicao :familiares="familiaresOrganizar" />
        </div>
        <div v-if="!loading" class="row">
            <div class="col-12 d-flex justify-content-end">
                <button class="btn btn-success" @click="submit">
                    <i class="mdi mdi-check-circle"></i> Salvar
                </button>
                <button class="btn btn-danger" @click="cancelar">
                    <i class="mdi mdi-close"></i> Cancelar
                </button>
            </div>
        </div>
    </b-modal>
</template>
<script>
import OrganizarPosicao from "./Remanejar/OrganizarPosicao";
export default {
    components: { OrganizarPosicao },
    props: ["familia", "pessoa"],
    data() {
        return {
            titulo: "Organizar a posição dos membros da familia",
            novo_responsavel: "",
            loading: false,
            organizarPosicoes: false,
            familiaresOrganizar: []
        };
    },
    watch: {
        familia() {
            this.organizar();
        }
    },
    mounted() {
        this.organizar();
    },
    methods: {
        submit() {
            this.loading = true;
            axios
                .post("api/dashboard/familias/trocarresponsavel", {
                    familiares: this.familiaresOrganizar
                })
                .then(response => {
                    this.loading = false;
                    this.cancelar();
                    this.$snack.success({
                        button: false,
                        text: "Posições organizadas com sucessos."
                    });
                    this.$emit("atualizar");
                });
        },
        organizar() {
            this.familiaresOrganizar = this.familia.familiares_ativos.filter(
                elem => parseInt(elem.posicao_familiar) > 1
            );
        },
        cancelar() {
            // Object.assign(this.$data, this.$options.data.call(this));
            this.$bvModal.hide("modal-remanejar-responsavel");
        }
    }
};
</script>
